import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import styled from "styled-components";
import { cloneDeep } from 'lodash';

import AgreeProvisionTextContent from '../Component/AgreeProvisionTextContent';
import ProvisionTextContent from '../Component/ProvisionTextContent';
//import DownModal from '../Component/DownModal';
import AddModal from '../Component/AddModal';
import DeleteModal from '../Component/DeleteModal';
import FetchModule from '../../../Model/Network/FetchModule';

export default function TermsPage(props) {

  // organizerId를 받기 위함 //
  const params = useParams();

  // 이벤트 주최자 이름 //
  const [organizer, setOrganizer] = useState('');

  // 이벤트 제목 //
  const [title, setTitle] = useState('');

  // 약관 다운 받기 클릭 여부 //
  const [isDownClicked, setIsDownClicked] = useState(false);

  // 약관 추가하기/수정하기 클릭 여부 //
  const [isEditClicked, setIsEditClicked] = useState(false);

  // 약관 삭제하기 클릭 여부 //
  const [isDeleteClicked, setIsDeleteClicked] = useState(false);

  // 변경될 약관 id //
  const [changedId, setChangedId] = useState(0);

  // 변경될 약관 제목 //
  const [changedTitle, setChangedTitle] = useState('');

  // 변경됦 약관 내용 //
  const [changedContent, setChangedContent] = useState('');

  // 최종 약관 본문 //
  const [provisions, setProvisions] = useState([]);

  // 디폴트 약관 본문 //
  const [defaultProvisions, setDefaultProvisions] = useState([]);

  // 커스텀 약관 본문 //
  const [customProvisions, setCustomProvisions] = useState([]);

  // 동의서 설정 본문 // 
  const [agreeProvisions, setAgreeProvisions] = useState([
    {
      id: 0,
      isDefault: true,
      title: '개인정보 이용 동의서\n[필수 동의]',
      text: '•  하이비스에 가입하고 시설을 이용하기 위해 아래와 같이 개인정보를 수집, 이용 및 제3자에게 위탁하고자 합니다. 내용을 자세히 읽으신 후 동의 여부를 결정해 주십시오.\n•  개인정보 제공자가 동의한 내용 외의 다른 목적으로 활용하지 않으며, 제공된 개인정보의 이용을 거부하고자 할 때에는 개인정보 관리책임자를 통해 열람, 정정 혹은 삭제를 요구할 수 있습니다.\n    •  개인정보 수집, 이용 내역 \n          •  항목 : 성명, 성별, 연락처, 생년월일, 주소, 유입경로 (+추가항목은 자동 추가)\n          •  수집, 이용 목적 : 회원가입, 상담, 상품 구매, 이용정보 및 공지사항 전달 관련 정보 제공을 위해 사용합니다.\n          •  개인정보의 보유 및 이용기간 : 수집,이용 동의일로부터 개인정보의 수집, 이용 목적을 달성할 때까지\n   •  개인정보 취급 업무 위탁 내역(고지사항)\n          •  위탁받는 자 : 링코 (주)하이비스\n          •  업무내용 : 회원 정보 관리\n   • 귀하께서는 본 안내에 따른 개인정보 수집, 이용에 대하여 동의를 거부하실 권리가 있습니다. 다만, 귀하가 개인정보의 수집/이용에 동의를 거부하시는 경우에 회원가입이 불가함을 알려드립니다.'
    },
    {
      id: 1,
      isDefault: true,
      title: '광고성 정보 이용 동의서\n[선택 동의]',
      text: '•  제공하신 정보(이름, 이메일 주소, 휴대폰 번호)는 하이비스의 마케팅 활용을 위해 사용합니다.\n    • 개인정보 제공자가 동의한 내용을 다른 목적으로 활용하지 않습니다.\n    • 귀하는 이에 대한 동의를 거부할 수 있습니다.\n    • 본 계약 만료 후 1년까지 보관합니다.'
    }
  ]);

  // 백엔드 연결 (센터 약관 불러오기) //
  useEffect(() => {
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.getDataOfEventVer2('terms/' + params.organizerId, 'GET');
        //console.log(responseData.data);
        if (responseData.status === 200) {
          setOrganizer(responseData.data.tournamentInfo.organizer);
          setTitle(responseData.data.tournamentInfo.title);

          const tempDefaultProvisions = responseData.data.defaultProvisions.map(item => ({
            ...item,
            isDefault: true
          }));

          const tempCustomProvisions = responseData.data.customProvisions.map(item => ({
            ...item,
            isDefault: false
          }));

          setDefaultProvisions(tempDefaultProvisions);
          setCustomProvisions(tempCustomProvisions);
        }
      }
    )();
  }, [params.organizerId]);

  // 최종 약관 합치기 //
  useEffect(() => {
    setProvisions([...defaultProvisions, ...customProvisions]);
  }, [defaultProvisions, customProvisions]);

  // 약관 다운 받기 모달 켜기 //
  const handleDownClicked = () => {
    if (isDownClicked === false) {
      setIsDownClicked(true);
    }
    else {
      setIsDownClicked(false)
    }
  };

  // 추가 모달 켜기 //
  const handleAddClicked = () => {
    setChangedId(0);
    setChangedTitle('');
    setChangedContent('');
    setIsEditClicked(!isEditClicked);
  };

  // 수정 모달 켜기 //
  function onClickProvisionEditModal(data) {
    setChangedId(data.id);
    setChangedTitle(data.title);
    setChangedContent(data.text);
    setIsEditClicked(true);
  };

  // 삭제 모달 켜기 //
  function onClickProvisonDeleteModal(data) {
    setChangedId(data.id);
    setChangedTitle(data.title);
    setChangedContent(data.text);
    setIsDeleteClicked(true);
  };

  // 삭제 모달에서 삭제하기 버튼 클릭시 (백엔드 API연결) //
  const onClickDelete = (data) => {
    let deleteData = {
      provisionId: data.id
    }
    const fetchModule = new FetchModule();
      (
        async () => {
          const responseData = await fetchModule.postDataOfEventVer2('terms/delete', 'POST', deleteData);
          //console.log(responseData.data);
          if (responseData.status === 200) {
            let prevCustomProvisions = cloneDeep(customProvisions);
            let newProvisions = prevCustomProvisions.filter((item) => item.id !== data.id);

            setCustomProvisions(newProvisions);
            setIsDeleteClicked(false);
          }
          else {
            alert('삭제에 실패했습니다\n잠시 후 다시시도해주세요');
          }
        }
      )();
  }

  // 추가/수정 모달에서 저장 버튼 클릭시 (백엔드 API연결) //
  function onClickSave(data) {
    if (changedTitle === '') {
      alert('저장할 규정의 제목을 입력해주세요');
      return;
    }
    else if (changedContent === '') {
      alert('저장할 규정의 내용을 입력해주세요');
      return;
    }

    let requestData = {
      organizerId: params.organizerId,
      provisionId: changedId,
      provisionTitle: changedTitle,
      provisionText: changedContent
    }

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataOfEventVer2('terms/save', 'POST', requestData);
        // console.log(responseData);
        if (responseData.status === 200) {

          let newData = {
            id: responseData.data.provisionId,
            title: responseData.data.provisionTitle,
            text: responseData.data.provisionText,
            isDefault: false
          };

          const checkIndex = customProvisions.findLastIndex((item) => item.id === newData.id);

          // 새로 추가한 customProvision일 경우
          if (checkIndex === -1) {
            setCustomProvisions([...customProvisions, newData]);
          }
          // 기존의 customProvision일 경우
          else {
            let prevCustomProvisions = cloneDeep(customProvisions);

            prevCustomProvisions[checkIndex].title = newData.title;
            prevCustomProvisions[checkIndex].text = newData.text;

            setCustomProvisions(prevCustomProvisions);
          }
        }
        else {
          alert(responseData.error);
        }
      }
    )();

    setIsEditClicked(false);
  }

  // 추가/삭제 모달에서 취소하기 버튼 클릭시 //
  const onClickExit = () => {
    setChangedId(0);
    setChangedTitle('');
    setChangedContent('');
    setIsEditClicked(false);
    setIsDeleteClicked(false);
  };



  return (
    <TopLevelWrapper>
      {/*{
        isDownClicked &&
        <DownModal
          organizer={organizer}
          title={title}
          provisions={provisions}
          setIsDownClicked={setIsDownClicked} />
      }*/}
      {
        isEditClicked &&
        <AddModal
          provisionId={changedId}
          provisionTitle={changedTitle}
          setProvisionTitle={setChangedTitle}
          provisionContent={changedContent}
          setProvisionContent={setChangedContent}

          onClickSave={onClickSave}
          onClickExit={onClickExit} />
      }
      {
        isDeleteClicked &&
        <DeleteModal
          provisionId={changedId}
          onClickDelete={onClickDelete}
          onClickExit={onClickExit} />
      }
      <TitleWrapper>
        {/*<ModifyButton isClicked={isDownClicked} onClick={handleDownClicked} background='#6DD49E'>
          <Text fontFamily='NotoSansKR-Bold' fontSize={14} color='#FFFFFF' hover='pointer'>약관 다운 받기</Text>
        </ModifyButton>*/}
      </TitleWrapper>


      <InfoView>
        <ProvisionWrapper>
          {
            provisions.map((data, index) => (
              <ProvisionTextContent
                key={'Provision-' + index}
                index={index}
                lastIndex={provisions.length - 1}
                data={data}
                organizer={organizer}
                title={title}
                onClickProvisionEditModal={onClickProvisionEditModal}
                onClickProvisonDeleteModal={onClickProvisonDeleteModal}
              />
            ))
          }
        </ProvisionWrapper>


        <InnerTextWrapper>
          <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' hover='default'>약관 항목 설정</Text>
        </InnerTextWrapper>
        <AddProvisionButtonWrapper>
          <AddProvisionButton onClick={handleAddClicked}>
            <StickWrapper width={14} height={14}>
              <Stick width={14} height={2} radius={2} backgroundColor='#000000' />
              <Stick width={2} height={14} radius={2} backgroundColor='#000000' />
            </StickWrapper>
            <Text fontFamily='NotoSansKR-Bold' fontSize={14} color='#000000' hover='pointer'>약관 추가 하기</Text>
          </AddProvisionButton>
        </AddProvisionButtonWrapper>


        <InnerTextWrapper>
          <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' hover='default'>동의서 설정</Text>
        </InnerTextWrapper>
        <AgreeProvisionWrapper>
          {
            agreeProvisions.map((data, index) => (
              <AgreeProvisionTextContent
                key={'AgreeProvision-' + index}
                index={index}
                data={data}
                organizer={organizer}
                title={title} />
            ))
          }
        </AgreeProvisionWrapper>
      </InfoView>

    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  width: 89%;
  height: 100%;
`;

// 제목단 //
const TitleWrapper = styled.div`
  display: flex;
  
  justify-content: flex-end;
  align-items: center;
  
  width: 100%;
`;

const ModifyButton = styled.div`
  display: flex;

  padding: 10px 20px;

  width: 84px;
  height: 20px;

  border-radius: 8px;
  border: 1px solid #6DD49E;
  background-color: ${props => props.background};

  :hover{
    cursor: pointer;
  }
`;

// 본 컴포넌트 //
const InfoView = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  alighn-items: center;

  width: 99.33%;
`;

// 본 규정 
const ProvisionWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  margin-top: 10px;

  width: calc(100% - 4px);
`;

// 추가 약관 항목 설정 
const AddProvisionButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  alighn-items: center;

  margin-top: 10px;

  width: 100%;
`;

const AddProvisionButton = styled.button`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  margin-bottom: 40px;
  padding: 0px 12px;

  height: 30px;

  gap: 4px;

  border-radius: 5px;
  border: 1px solid #6DD49E;
  background-color: #6DD49E;

  :hover{
    cursor: pointer;
  }
`;

const StickWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: ${props => props.width}px;
  height: ${props => props.height}px;
`;

const Stick = styled.div`
  position: absolute;

  width: ${props => props.width}px;
  height: ${props => props.height}px;

  border-radius: ${props => props.radius}px;
  background-color: ${props => props.backgroundColor};

  :hover{
    cursor: pointer;
  }
`;

// 동의서 설정 //
const AgreeProvisionWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  margin-top: 10px;

  width: calc(100% - 4px);

  border-radius: 10px;
  border: 1px solid #969696;
`;


//####################
//###### TEXT ########
//####################
const InnerTextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  margin-top: 14px;
  padding: 4px 0px 14px 0px;

  width: 1051px;

  border-bottom: 2px solid #969696;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;
  
  :hover {
    cursor: ${props => props.hover};
  }

  transition: all 0.3s ease-in-out;
`;